export const allowedLanguages = {
  PT: 'pt',
  ES: 'es',
  IT: 'it',
  FR: 'fr',
  PL: 'pl',
  NL: 'nl',
  DE: 'de',
  CN: 'zh_cn',
  EN: 'en'
};

export const supportedDateLocales = Object.values(allowedLanguages);
